import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const apiGetHelpByPregunta = async (idpregunta) => {
  const rs = await request(API_ROUTES.getHelpQuestions(idpregunta), {
    method: "GET",
  });
  return rs.json();
};

export const apiSaveHelp = async (formHelp) => {
  const res = await request(API_ROUTES.saveHelpQuestions, {
    method: "POST",
    body: JSON.stringify(formHelp),
  });
  return res.json();
};

export const apiDeleteHelp = async (id) => {
  const payload = typeof id === "object" ? id : { id };
  const res = await request(API_ROUTES.deleteHelpQuestion, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export default {
  apiGetHelpByPregunta,
  apiSaveHelp,
  apiDeleteHelp,
};
